window.nextEegCalculator = window.nextEegCalculator || {}

window.nextEegCalculator.resizeIframe = height => {
  const iframe = document.getElementById('next-eeg-rechner-app-iframe')

  if (iframe) {
    iframe.style.height = height + 'px'
  }
}
